import { ClockIcon, EnvelopeIcon } from 'images/svg';
import { useTranslation } from 'next-i18next';
import Link from 'next/link';

interface Props {
  email: string;
}

const SupportEmail = (props: Props) => {
  const { email } = props;
  const { t } = useTranslation();

  return (
    <div className="support-email">
      <div>
        <EnvelopeIcon />
        <h3 className="support-email__header header">
          {t('supportEmail.header')}
        </h3>
        <Link href={`mailto:${email}`} legacyBehavior>
          <a className="support-email__link">{email}</a>
        </Link>
      </div>
      <div className="support-email__footnotes">
        <ClockIcon />
        <span>{t('supportEmail.footnotes')}</span>
      </div>
    </div>
  );
};

export default SupportEmail;
